import { API_AUTH, setTokenGlobal } from "../common";
import { Cookies } from "react-cookie";
import { getDomain, getUserLogin } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
    token = token.substring(6);
    setTokenGlobal(token, urlNew);
}
export default {

    chiTietDonHang: (orderdathangId) => {
        return API_AUTH.get(`dathang/GetDonHangByOrderDatHangID?orderdathangId=${orderdathangId}`, {});
    },

    list: ({
        fromDate,
        toDate,
        sSearch,
        sUserName,
        sCustomerName,
        iTrangThaiTruKho,
        iTrangThaiThanhToan,
        iBranch,
        sBranch,
        sNVKDUserName,
        lstNhomKH,
        iLoaiDon,
        iLoaiDoiTac,
        iPageIndex,
        iPageSize,
        TinhThanhPhoId,
        QuanhuyenId,
        PhuongxaId,
    }) =>
        API_AUTH.get(
            `dathang/DanhSachDonHangCuaDatHang?fromDate=${fromDate}&toDate=${toDate}&sSearch=${sSearch}&sUserName=${sUserName}&sCustomerName=${sCustomerName}&iTrangThaiTruKho=${iTrangThaiTruKho}&iTrangThaiThanhToan=${iTrangThaiThanhToan}&iBranch=${iBranch}&sBranch=${sBranch}&sNVKDUserName=${sNVKDUserName}&lstNhomKH=${lstNhomKH}&iLoaiDon=${iLoaiDon}&iLoaiDoiTac=${iLoaiDoiTac}&iPageIndex=${iPageIndex}&iPageSize=${iPageSize}&TinhThanhPhoId=${TinhThanhPhoId}&QuanhuyenId=${QuanhuyenId}&PhuongxaId=${PhuongxaId}`,
            {}
        ),

    InDanhSachDonHangCuaDatHang: (
        fromDate,
        toDate,
        sSearch,
        sUserName,
        iTrangThaiThanhToan,
    ) =>
        API_AUTH.get(
            `dathang/InDanhSachDonHangCuaDatHang?fromDate=${fromDate}&toDate=${toDate}&sSearch=${sSearch}&sUserName=${sUserName}&iTrangThaiThanhToan=${iTrangThaiThanhToan}`,
            {}
        ),

};



